import { render } from "./SignatureForm.vue?vue&type=template&id=282a68b3"
import script from "./SignatureForm.vue?vue&type=script&lang=js"
export * from "./SignatureForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__